import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { PAGE_BREAKPOINTS } from '../../../../../../constants/commonConstants';
import { useBreakpoint } from '../../../../../../hooks';
import cx from 'classnames';
import { v4 as uuid } from 'uuid';
import { ComponentLoaderProps } from '../../../types';

export const ComponentLoader = ({ classname }: ComponentLoaderProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const loaderCount = !isMD ? [...Array(4)] : [...Array(6)];

  return (
    <div className={cx(classname, 'w-100')}>
      <div className="mb-4">
        <CatSkeleton width="305px" />
      </div>
      {loaderCount.map((_value) => {
        return (
          <div key={uuid()} className="mb-2 w-100">
            <CatSkeleton size="lg" />
          </div>
        );
      })}
    </div>
  );
};

export default ComponentLoader;
